import classStyle from './Install.module.scss';
import React, { useEffect } from 'react';
import logo from '@src/assets/logo.png';
import logo_en from '@src/assets/logo_en.png';
import bgLogo from '@src/assets/bgLogo.png';
import cardLogo from '@src/assets/cardLogo.png';
import cardImg from '@src/assets/cardImg.png';
import cardLogoEn from '@src/assets/cardLogoEn.png';
import { QRCode } from 'react-qrcode-logo';
import { useWindowDimensions } from '@src/hooks';
import { downloadUrl, iosInstallList, androidInstallList } from '@src/baseUrl';
import {  isIOS, isAndroid } from '@src/unit';
import Services from '@src/api/services';
import { stepList } from './installData';
import { useTranslation } from 'react-i18next';
import { getUserLanguage } from '@src/i18n';
import { getFP, getIP, sendFp, handleDownloadPWA } from '@src/container/common/tools';

export default function Install() {
    const { i18n } = useTranslation();
    const { width } = useWindowDimensions();

    useEffect(() => {
        async function fetchData() {
            let ip = await getIP();
            getFP(ip);
        }
        fetchData();
        // 下載頁不抓LocalStorage每次抓瀏覽器預設
        i18n.changeLanguage(getUserLanguage(false));
        // i18n.changeLanguage('en');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if ( width <= 768) {
        return <MobileInstall />;
    } else {
        return <PcInstall width={width} />;
    }
}

const MobileInstall = () => {
    const { t, i18n } = useTranslation();
    const isCn = i18n.language === 'zh';

    const handleDownload = async ({ url, pingUrl, domain }) => {
        if (isAndroid) await sendFp();

        Services.appDownloadRecord({
            deviceType: isIOS ? 1 : 2,
            domain: pingUrl,
        })
            .then((res) => {
                console.log('kailog', res);
            })
            .finally(() => {
                if (isIOS) {
                    return handleDownloadPWA(domain, isCn);
                } else {
                    window.location.href = url;
                }
            });
    };
    // 測速
    const handlePingList = (list) => {
        let isPingEnd = false;

        list.forEach((item) => {
            const img = new Image();
            const startTime = new Date().getTime();
            img.src = `${item.pingUrl}?d=${startTime}`;
            img.onload = () => {
                const endTime = new Date().getTime();
                const delta = endTime - startTime;
                console.log('kailog', delta);
                console.log('kailog', item);

                if (isPingEnd === false) {
                    isPingEnd = true;

                    handleDownload(item);
                }
            };
        });
    };

    return (
        <div className={classStyle.mobilePage}>
            <div className={classStyle.mainBg}>
                <img
                    src={isCn ? logo : logo_en}
                    className={isCn ? classStyle.logo : classStyle.logoEn}
                    alt=""
                />
                <img src={bgLogo} className={classStyle.bgLogo} alt="" />
                <div className={classStyle.logoText}>{t('mobileTitle')}</div>
                <div
                    className={classStyle.button}
                    onClick={() => {
                        if (isIOS) {
                            handlePingList(iosInstallList);
                        } else {
                            handleDownload(androidInstallList[0]);
                        }
                    }}
                >
                    {t('downloadApp')}
                </div>
                {isAndroid && (
                    <div
                        className={classStyle.button2}
                        onClick={() => {
                            handleDownload(androidInstallList[1]);
                        }}
                    >
                        {t('downloadApp2')}
                    </div>
                )}
                {isIOS && <StepList />}
            </div>
            {/* {showIframe && (
                <iframe title="saveUrl" className={classStyle.iframe} src={iosInstallUrl} />
            )}
            {showIframe2 && (
                <iframe title="toSettingUrl" className={classStyle.iframe} src={toSettingUrl} />
            )} */}
        </div>
    );
};

const StepList = () => {
    const { t, i18n } = useTranslation();
    const isCn = i18n.language === 'zh';

    return (
        <div className={classStyle.list}>
            {stepList.map((item, index) => {
                return (
                    <div className={classStyle.item} key={index}>
                        <div className={classStyle.itemTitle}>{item.title}</div>
                        <img
                            className={classStyle.itemImg}
                            src={isCn ? item.img : item.imgEn}
                            alt=""
                        />
                        <div className={classStyle.itemText}>{t(item.text)}</div>
                    </div>
                );
            })}
        </div>
    );
};

const PcInstall = ({ width }) => {
    const { t, i18n } = useTranslation();
    const isCn = i18n.language === 'zh';
    let size = (width / 1920) * 140;
    let merchantCode = new URLSearchParams(window.location.search).get('merchantCode');
    let param = merchantCode != null ? `?merchantCode=${merchantCode}` : '';

    // if (width >= 1200) {
    //     size = 140 * 0.75;
    // }

    if (width >= 1920) {
        size = 140;
    }

    return (
        <div className={classStyle.pcPage}>
            <div className={classStyle.mainBg}>
                <div className={classStyle.mainBgInfo}>
                    <div className={classStyle.mainBgInfoBar}>
                        <div className={classStyle.mainBgInfoLeft}>
                            <img
                                src={isCn ? logo : logo_en}
                                className={isCn ? classStyle.logo : classStyle.logoEn}
                                alt=""
                            />
                            <div className={classStyle.logoText}>{t('logoText')}</div>
                            <div className={classStyle.logoSubText}>{t('logoSubText')}</div>
                            <div className={classStyle.qrCode}>
                                <QRCode value={`${downloadUrl}${param}`} size={size} />
                                <div className={classStyle.qrCodeText}>{t('qrCodeText')}</div>
                            </div>
                        </div>
                        <div className={classStyle.mainBgInfoRight}>
                            <img
                                src={isCn ? cardLogo : cardLogoEn}
                                className={classStyle.mainBgInfoRightImg}
                                alt=""
                            />
                            <div className={classStyle.rightImgCard}>
                                <div className={classStyle.cardTitle}>{t('cardTitle')}</div>
                                <div className={classStyle.cardText}>{t('cardText')}</div>
                            </div>
                            <div className={classStyle.rightImgCard2}>
                                <img src={cardImg} className={classStyle.cardImg} alt="" />
                                <div className={classStyle.cardTitle}>{t('cardTitle2')}</div>
                                <div className={classStyle.cardText}>{t('cardText2')}</div>
                            </div>
                        </div>
                    </div>
                    <div className={classStyle.downloadText}>{t('downloadText')}</div>
                </div>
                <StepList />
            </div>
        </div>
    );
};
